<template>
  <TheAdminProfile />
</template>
<script>
import TheAdminProfile from '@/components/Profile/TheAdminProfile'

export default {
  name: 'Profile',

  components: {
    TheAdminProfile
  }
}
</script>
